import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const GetStaffStaffingRatioRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string().optional(),
  to: z.string().optional(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

export const GetStaffStaffingRatioResponseDtoSchema = z.object({
  currentValue: z.number().nullable(),
  marketMedian: z.number().nullable(),
  hint: z.string(),
  message: z.string(),
});

export type GetStaffStaffingRatioRequestDto = z.infer<
  typeof GetStaffStaffingRatioRequestDtoSchema
>;

export type GetStaffStaffingRatioResponseDto = z.infer<
  typeof GetStaffStaffingRatioResponseDtoSchema
>;

export const getStaffStaffingRatio = async (
  params: GetStaffStaffingRatioRequestDto,
  config?: AxiosRequestConfig<GetStaffStaffingRatioRequestDto>
) => {
  const { facilityId, from, to, ...restParams } = params;

  // Transform dates to YYYY-MM format (backend expects month precision)
  const cleanParams = {
    ...Object.fromEntries(
      Object.entries(restParams).filter(([_, value]) => value !== undefined)
    ),
    ...(from && { from: from.slice(0, 7) }),
    ...(to && { to: to.slice(0, 7) }),
  };

  return api
    .get(`/market-intelligence/facilities/${facilityId}/staff-staffing-ratio`, {
      params: cleanParams,
      ...config,
    })
    .then(responseContract(GetStaffStaffingRatioResponseDtoSchema));
};
